exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fullpage-demo[data-v-69717e73]{background-color:#ff0;font-size:72px;line-height:320px;text-align:center}", ""]);

// exports
